// ============================================
// Application Constants — Single Source of Truth
// ============================================

// --- College Identity ---
export const COLLEGE = {
  NAME: 'Government Degree College',
  FULL_NAME: 'Government Degree College, Beekapur, Ayodhya',
  SHORT_NAME: 'GDC Beekapur',
  ADDRESS_LINE: 'Beekapur, Ayodhya, 224284',
  FULL_ADDRESS: 'Government Degree College, Beekapur, Ayodhya, 224284, Uttar Pradesh, India',
  CITY: 'Beekapur',
  DISTRICT: 'Ayodhya',
  PIN: '224284',
  STATE: 'Uttar Pradesh',
  COUNTRY: 'India',
  PHONE: '+91 82998 66286',
  EMAIL: 'gdcbeekapur@gmail.com',
  WEB_ADMIN_PHONE: '+91 9415374934',
  LOGO_PATH: '/college-logo.jpg',
  COORDINATES: { lat: 26.635833, lng: 82.055389 },
  COORDINATES_DMS: "26°38'09.0\"N, 82°03'19.4\"E",
  HINDI_NAME: 'राजकीय महाविद्यालय',
  HINDI_CITY: 'बीकापुर, अयोध्या',
  MOTTO: 'तमसो मा ज्योतिर्गमय',
};

// --- Bank Details ---
export const BANK = {
  NAME: 'Bank of Baroda',
  BRANCH: 'Shahganj, Ayodhya',
  ACCOUNT_NUMBER: '14300100028747',
  DISPLAY: 'Bank of Baroda – 14300100028747',
};

// --- Hero Images ---
export const HERO_IMAGES = [
  '/collegehero1.jpeg',
  '/collegehero2.jpeg',
  '/collegehero3.jpeg',
  '/collegehero4.jpeg',
];

// --- Degrees ---
export const DEGREES = [
  { value: 'B.Sc', label: 'Bachelor of Science (B.Sc)' },
  { value: 'B.A', label: 'Bachelor of Arts (B.A)' },
  { value: 'B.Com', label: 'Bachelor of Commerce (B.Com)' },
  { value: 'M.Sc', label: 'Master of Science (M.Sc)' },
  { value: 'M.A', label: 'Master of Arts (M.A)' },
  { value: 'M.Com', label: 'Master of Commerce (M.Com)' },
];

export const DEGREE_LIST = DEGREES.map(d => d.value);

// --- Courses ---
export const COURSES = [
  {
    id: 1,
    name: 'Bachelor of Science (B.Sc.)',
    duration: '3 Years',
    description: 'A comprehensive undergraduate program covering fundamental sciences.',
    eligibility: 'Inter Science',
  },
  {
    id: 2,
    name: 'Bachelor of Arts (B.A.)',
    duration: '3 Years',
    description: 'Liberal arts program focusing on humanities and social sciences.',
    eligibility: '10+2 in any stream',
  },
  {
    id: 3,
    name: 'Bachelor of Commerce (B.Com.)',
    duration: '3 Years',
    description: 'Professional program in commerce and business administration.',
    eligibility: 'Inter Commerce / Science',
  },
];

// --- Departments ---
export const DEPARTMENTS = [
  'History',
  'Geography',
  'Political Science',
  'Humanities',
  'Science',
  'Commerce',
  'English',
  'Hindi',
  'Mathematics',
  'Physics',
  'Chemistry',
  'Sanskrit',
  'Botany',
  'Zoology',
  'Sociology',
  'Physical Education',
  'Computer Science',
];

// --- Faculty Designations ---
export const DESIGNATIONS = [
  'Professor',
  'Associate Professor',
  'Assistant Professor',
  'Lecturer',
  'Guest Faculty',
];

// --- Demographics ---
export const CASTES = [
  { value: 'general', label: 'General' },
  { value: 'obc', label: 'OBC' },
  { value: 'sc', label: 'SC' },
  { value: 'st', label: 'ST' },
];

export const GENDERS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'others', label: 'Others' },
];

export const RELIGIONS = [
  { value: 'hindu', label: 'Hindu' },
  { value: 'muslim', label: 'Muslim' },
  { value: 'other', label: 'Other' },
];

// --- Semesters ---
export const SEMESTERS = [
  { value: '1', label: 'First Semester' },
  { value: '2', label: 'Second Semester' },
  { value: '3', label: 'Third Semester' },
  { value: '4', label: 'Fourth Semester' },
  { value: '5', label: 'Fifth Semester' },
  { value: '6', label: 'Sixth Semester' },
  { value: '7', label: 'Seventh Semester' },
  { value: '8', label: 'Eighth Semester' },
];

// Registration form only allows odd semesters
export const REGISTRATION_SEMESTERS = SEMESTERS.filter(s => ['1', '3', '5'].includes(s.value));

// --- Semesters with display labels (for receipts etc.) ---
export const SEMESTER_LABELS = {
  1: 'First', 2: 'Second', 3: 'Third', 4: 'Fourth',
  5: 'Fifth', 6: 'Sixth', 7: 'Seventh', 8: 'Eighth',
};

// --- Application Config ---
export const APP_CONFIG = {
  NAME: 'Student Fee Management System',
  VERSION: '1.0.0',
  COLLEGE_NAME: COLLEGE.FULL_NAME,
};

// --- Firebase Collections ---
export const FIREBASE_COLLECTIONS = {
  STUDENTS: 'students',
  PAYMENTS: 'payments',
  SUBJECTS: 'subjects',
  FACULTY: 'faculty',
  GALLERY: 'gallery',
  ADMIN: 'admin',
  PASSWORD_HISTORY: 'password_history',
};

// --- Payment Status ---
export const PAYMENT_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

// --- User Roles ---
export const USER_ROLES = {
  ADMIN: 'admin',
  STUDENT: 'student',
  FACULTY: 'faculty',
};

// --- File Upload Limits ---
export const FILE_LIMITS = {
  IMAGE_MAX_SIZE: 5 * 1024 * 1024,    // 5MB for gallery/faculty images
  DOCUMENT_MAX_SIZE: 10 * 1024 * 1024, // 10MB for AISHE reports/documents
};


